( function( $ ) {
	'use strict';

	$( function() {
		const activeClass = 'is-active';
		const slideDuration = 400;
		const $trigger = $( '.site-footer__menu .nav-menu__item.has-children .nav-menu__link' );

		$trigger.on( 'click', function(e) {
			e.preventDefault();
			const $thisTrigger = $( this );
			const $body = $( this ).closest( '.nav-menu__item' ).find( '.nav-menu-submenu' );

			if ( $thisTrigger.attr( 'aria-expanded' ) === 'false' || ! $thisTrigger.attr( 'aria-expanded' ) ) {
				$thisTrigger.attr( 'aria-expanded', true );
			} else {
				$thisTrigger.attr( 'aria-expanded', false );
			}

			$body.stop().slideToggle( slideDuration );
		} );
	} );
} )( jQuery );
